<template>
    <div class="index">
        <div class="out_box">
            <div class="header_title u-f u-ac">
                <div @click="backpage" class="icon iconfont icon-a-zuojiantouzhixiangzuojiantou backbtn"></div> 机构申请入驻
            </div>
            <div class="lc_body">
                <div class="bodys">
                    <div class="lines_b">
                        <div class="stepitem" v-for="(st,index) in steps" :key="index">
                            <div class="steps">
                                <div class="l" :class="stepindex==index+1?'l2':'l1'"></div>
                                <div class="step_text">{{st.name}}</div>
                            </div>
                            <div class="step_line" v-if="index<steps.length-1"></div>
                        </div>
                    </div>
                    <div class="forms_b">
                        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="30px"
                            class="demo-ruleForm">
                            <div v-show="stepindex==1">
                                <el-form-item label="" prop="user_name">
                                    <div>用户名<span style="color:red">*</span></div>
                                    <el-input v-model="ruleForm.user_name" placeholder="输入用户名" size="medium"></el-input>
                                </el-form-item>
                                <el-form-item label="" prop="user_pwd">
                                    <div>账号密码<span style="color:red">*</span></div>
                                    <el-input v-model="ruleForm.user_pwd" placeholder="输入密码" size="medium"></el-input>
                                </el-form-item>
                                <el-form-item label="" required>
                                    <div>头像<span style="color:red">*</span></div>
                                    <el-upload class="avatar-uploader" action="/admin/pc/fpUpload" name="img" :limit="1"
                                        ref="upload" :headers="{ }" :data="{ image_class_id:'2'}"
                                        :file-list="ruleForm.pic_mapList" :on-success="uploadSuccess"
                                        :on-remove="uploadRmove" list-type="picture-card">
                                        <i class="el-icon-plus"></i>
                                        <!-- verification:1,fileS:2,fileH:300,fileW:300  -->
                                    </el-upload>
                                </el-form-item>
                            </div>
                            <div v-show="stepindex==2">
                                <el-form-item label="" prop="mcn_abbreviation">
                                    <div>机构简称<span style="color:red">*</span></div>
                                    <el-input v-model="ruleForm.mcn_abbreviation" placeholder="机构对外展示的简称"
                                        size="medium">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="" prop="mcn_name">
                                    <div>主体名称<span style="color:red">*</span></div>
                                    <el-input v-model="ruleForm.mcn_name" placeholder="机构营业执照的完成注册名称" size="medium">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="" prop="name">
                                    <div>机构地址<span style="color:red">*</span></div>
                                    <div class=" u-f">
                                        <el-form-item prop="province_code" style="margin-right:10px">
                                            <el-select style="width:112px" v-model="ruleForm.province_code"
                                                placeholder="请选择" size="small" @change="getsq">
                                                <el-option v-for="item in sf_options" :key="item.code"
                                                    :label="item.name" :value="item.code">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item prop="city_code" style="margin-right:10px">
                                            <el-select style="width:112px" v-model="ruleForm.city_code"
                                                placeholder="请选择" size="small" clearable @change="getqy">
                                                <el-option v-for="item in sq_options" :key="item.code"
                                                    :label="item.name" :value="item.code">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item prop="area_code" style="margin-right:10px">
                                            <el-select style="width:112px" v-model="ruleForm.area_code"
                                                placeholder="请选择" size="small" clearable>
                                                <el-option v-for="item in qy_options" :key="item.code"
                                                    :label="item.name" :value="item.code">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                    <el-form-item prop="mcn_address">
                                        <el-input v-model="ruleForm.mcn_address" placeholder="详细地址" size="medium">
                                        </el-input>
                                    </el-form-item>

                                </el-form-item>
                                <el-form-item label="" prop="business_license_code">
                                    <div>社会统一信用码<span style="color:red">*</span></div>
                                    <el-input v-model="ruleForm.business_license_code" placeholder="请填写营业执照的18位"
                                        size="medium">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="" required>
                                    <div>营业执照<span style="color:red">*</span></div>
                                    <el-upload class="avatar-uploader" action="/admin/pc/fpUpload" name="img"
                                        ref="upload" :headers="{ }" :data="{ image_class_id:'2'}"
                                        :file-list="ruleForm.yyzz_mapList" :on-success="uploadSuccess2"
                                        :on-remove="uploadRmove2" list-type="picture-card">
                                        <i class="el-icon-plus"></i>
                                        <!-- verification:1,fileS:2,fileH:300,fileW:300  -->
                                    </el-upload>
                                </el-form-item>
                            </div>
                            <div v-show="stepindex==3">
                                <el-form-item label="" prop="manager_name">
                                    <div>管理员姓名<span style="color:red">*</span></div>
                                    <el-input v-model="ruleForm.manager_name" placeholder="请填写管理员姓名" size="medium">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="" prop="manager_phone">
                                    <div>管理员手机号<span style="color:red">*</span></div>
                                    <el-input v-model="ruleForm.manager_phone" placeholder="请填写管理员手机号"
                                        size="medium">
                                    </el-input>
                                </el-form-item>
                            </div>
                        </el-form>
                    </div>
                </div>
                <div class="btns">
                    <el-button type="text" @click="pevstep" v-if="stepindex>1">上一步</el-button>
                    <el-button class="nextbtn" size="medium" @click="nextstep('ruleForm')" type="primary"
                        :loading='submitloading'>
                        {{stepindex==steps.length?'完成':'下一步'}}</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                steps: [{
                        id: 1,
                        name: '登录账号信息'
                    },
                    {
                        id: 2,
                        name: '机构信息'
                    },
                    {
                        id: 3,
                        name: '管理员信息'
                    },
                ],
                stepindex: 1,
                ruleForm: {
                    user_name: '',
                    user_pwd: '',
                    province_code: '',
                    city_code: '',
                    area_code: '',
                    pic_mapList: [],
                    yyzz_mapList: [],
                    mcn_address: '',
                    mcn_name: '',
                    mcn_abbreviation: '',
                    business_license_code: '',
                    manager_name: '',
                    manager_phone: '',

                },

                rules: {
                    user_name: [{
                        required: true,
                        message: '请输入用户名',
                        trigger: 'blur'
                    }, ],
                    user_pwd: [{
                        required: true,
                        message: '请输入账号密码',
                        trigger: 'blur'
                    }, ],
                    mcn_name: [{
                        required: true,
                        message: '请输入主体名称',
                        trigger: 'blur'
                    }, ],
                    mcn_abbreviation: [{
                        required: true,
                        message: '请输入机构简称',
                        trigger: 'blur'
                    }, ],
                    province_code: [{
                        required: true,
                        message: '请选择省',
                        trigger: 'blur'
                    }, ],
                    city_code: [{
                        required: true,
                        message: '请选择市',
                        trigger: 'blur'
                    }, ],
                    area_code: [{
                        required: true,
                        message: '请选择区',
                        trigger: 'blur'
                    }, ],
                    business_license_code: [{
                        required: true,
                        message: '请输入社会统一信用码',
                        trigger: 'blur'
                    }, ],
                    manager_name: [{
                        required: true,
                        message: '请输入管理员姓名',
                        trigger: 'blur'
                    }, ],
                    manager_phone: [{
                        required: true,
                        message: '请输入管理员手机号',
                        trigger: 'blur'
                    }, ],
                    pic_mapList: [{
                        required: true,
                        message: '请上传头像',
                        trigger: 'blur'
                    }, ],
                    yyzz_mapList: [{
                        required: true,
                        message: '请上传营业执照',
                        trigger: 'blur'
                    }, ],
                    mcn_address: [{
                        required: true,
                        message: '请输入详细地址',
                        trigger: 'blur'
                    }, ],
                },
                sf_options: [],
                sq_options: [],
                qy_options: [],
                business_license_pic: [],
                user_avatar: [],
                submitloading: false
            }
        },
        mounted() {
            this.getsf()
        },
        methods: {
            uploadSuccess(response, file, fileList) {
                let that = this
                if (response.code == "201") {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.upload;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(response.msg)
                    return;
                }
                that.$message({
                    message: '上传成功',
                    type: 'success'
                });
                that.user_avatar.push(response.data)
            },
            uploadRmove(file, fileList) {
                var index = this.user_avatar.findIndex(item => item.id == file.id)
                this.user_avatar.splice(index, 1)
            },
            uploadSuccess2(response, file, fileList) {
                let that = this
                if (response.code == "201") {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.upload;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(response.msg)
                    return;
                }
                that.$message({
                    message: '上传成功',
                    type: 'success'
                });
                that.business_license_pic.push(response.data)
            },
            uploadRmove2(file, fileList) {
                var index = this.business_license_pic.findIndex(item => item.id == file.id)
                this.business_license_pic.splice(index, 1)
            },
            // 获取省份
            getsf() {
                let that = this
                axios
                    .post("/admin/h5/Area/getProvince_vue", {}, {
                        token: true
                    })
                    .then(response => {
                        that.sf_options = response.data.data
                    })
                    .catch(error => {})
            },
            getsq() {
                let that = this
                that.sq_options = []
                that.ruleForm.city_code = ''
                that.qy_options = []
                that.ruleForm.area_code = ''
                axios
                    .post("/admin/h5/Area/getChild_vue", {
                        parentcode: that.ruleForm.province_code,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.sq_options = response.data.data
                    })
                    .catch(error => {})
            },
            getqy() {

                let that = this
                that.qy_options = []
                that.ruleForm.area_code = ''
                axios
                    .post("/admin/h5/Area/getChild_vue", {
                        parentcode: that.ruleForm.city_code,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.qy_options = response.data.data
                    })
                    .catch(error => {})
            },
            nextstep(formName) {
                if (this.stepindex < this.steps.length) {
                    this.stepindex++
                } else {
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            this.register(this.ruleForm);
                        } else {
                            this.$message('有必填项未填')
                            return false;
                        }
                    });
                }

            },
            register(arr) {
                if (this.user_avatar.length == 0) return this.$message('请上传头像')
                if (this.business_license_pic.length == 0) return this.$message('请上传营业执照')
                if (!/^1[3-9]\d{9}$/.test(arr.manager_phone)) return this.$message('手机号格式不正确')
                this.submitloading = true
                let params = {
                    mcn_name: arr.mcn_name,
                    mcn_abbreviation: arr.mcn_abbreviation,
                    mcn_address: arr.mcn_address,
                    manager_name: arr.manager_name,
                    manager_phone: arr.manager_phone,
                    province_code: arr.province_code,
                    city_code: arr.city_code,
                    area_code: arr.area_code,
                    business_license_code: arr.business_license_code,
                    business_license_pic: this.business_license_pic,
                    user_name: arr.user_name,
                    user_pwd: arr.user_pwd,
                    user_avatar: this.user_avatar,
                    is_update: 2
                }
                this.axios.post('/admin/h5/mcn/toExamine', params).then(res => {
                    this.submitloading = false
                    if (res.data.code == 200) {
                        this.$alert('提交成功，请等待管理员审核', '确定', {
                            confirmButtonText: '确定',
                            type: 'success',
                            center: true,
                            showCancelButton: false,
                            confirmButtonClass: 'warnbtn',
                            callback: action => {
                                setTimeout(() => {
                                    this.$router.go(-2)
                                }, 500)
                            }
                        })

                    } else {
                        this.$message.error(res.data.msg)
                    }
                }).catch(err => {
                    this.submitloading = false
                    this.$message.error('异常！')
                })

            },
            pevstep() {
                this.stepindex--
            },
            backpage() {
                this.$router.go(-1)
            }

        }
    }
</script>

<style lang="scss" scoped>
    #app {
        height: 100%;
    }
    .el-form-item{
        margin-bottom: 8px !important;
    }

    .index {
       background-image: url('../../assets/imgs/login_bgimg.jpg');
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
        height: 100vh;
        // height: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        overflow: auto;

        .out_box {
            background-color: #fff;
            border-radius: 8px;
            margin-top: 100px;

            .header_title {
                padding: 20px 25px;
                font-size: 20px;
                font-weight: 600;

                .backbtn {
                    font-size: 25px;
                    margin-right: 15px;
                    cursor: pointer;
                }

            }

            .lc_body {
                margin-top: 35px;
                min-height: 550px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .bodys {
                    display: flex;

                    .lines_b {
                        padding: 11px 45px;

                        .stepitem {
                            display: flex;
                            flex-direction: column;
                            align-items: flex-start;
                        }

                        .steps {
                            display: flex;
                            align-items: center;

                            .l {
                                width: 16px;
                                height: 16px;
                                border: 2px solid #fff;
                                box-shadow: 1px 1px 5px 1px rgba($color: #000000, $alpha: .8);
                                border-radius: 50%;
                                margin-right: 8px;
                            }

                            .l1 {
                                background-color: #AEAEAE;
                            }

                            .l2 {
                                background-color: #348080;
                            }

                            .step_text {
                                font-size: 14px;
                                font-weight: 600;
                            }
                        }

                        .step_line {
                            width: 2px;
                            height: 80px;
                            background-color: #8C8C8C;
                            margin: 5px 7px;
                        }
                    }

                    .forms_b {
                        min-width: 450px;
                        padding-right: 50px;
                    }
                }

                .btns {
                    text-align: center;

                    padding: 20px 0 30px;

                    .nextbtn {
                        width: 260px;
                        border-radius: 8px;
                    }
                }
            }
        }
    }
</style>